<template>
	<div class="rc">
		<div class="lt-left">
			<div ref="cmain1" class="cmain" :style="{ width: '460px', height: '220px' }"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'template4.leftBottom4',
	data() {
		return {
			myChart: "",
			option: "",
			TmyChart: "",
			Toption: "",

		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {
		cDrawCircle() {
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.cmain1);
			let yValue = ['商品销售名称', '商品销售名称', '商品销售名称', '商品销售名称'];
			var itemColor = [['#78dcfe', '#054585',],
			['#4dfdb2', '#167140',],
			['#d7d6d5', '#84807e',],
			['#d8a94d', '#af7322',],]

			let xValue = [100, 80, 50, 30];
			var Toption = {
				//盒子位置
				grid: {
					top: '5%',
					bottom: '0%',
					left: '12px',
					right: '8%'
					// containLabel: false
				},
				// 提示框组件
				xAxis: {
					nameTextStyle: {
						color: 'rgba(255, 255, 255, 0.8)',
						align: 'right'
					},
					splitLine: {
						show: false,
					},
					axisLine: {
						show: false,
					},
					axisLabel: {
						color: 'rgba(255, 255, 255, 0.8)'
					},
				},
				// 配置 y 轴
				yAxis: [
					{
						// y 轴类型为分类轴
						type: "category",
						// 不显示 y 轴刻度线
						axisTick: "none",
						// 不显示 y 轴轴线
						axisLine: "none",
						// 升序排列
						inverse: true,
						// 不显示 y 轴的线
						axisLine: {
							show: false
						},
						// 刻度线与标签对齐，且不显示刻度线
						axisTick: {
							alignWithLabel: true,
							show: false
						},
						// 显示 y 轴标签，标签在轴内侧左对齐，垂直底部对齐，行高 50，颜色为 #D6EEF6，字体大小为 16
						axisLabel: {
							show: true,
							inside: true,
							align: "left",
							verticalAlign: 'bottom',
							lineHeight: 50,
							color: '#D6EEF6',
							fontSize: 16,
						},
						// y 轴数据
						data: yValue
					},
					{
						// 不显示 y 轴刻度线
						axisTick: "none",
						// 不显示 y 轴轴线
						axisLine: "none",
						// y 轴标签文本样式，颜色为白色，字体大小为 16
						axisLabel: {
							textStyle: {
								color: "#ffffff",
								fontSize: "16",
							},
						},
						// y 轴数据
						data: xValue,
						// 不显示该 y 轴
						show: false,
					},
					{
						// 刻度线与标签对齐，且不显示刻度线
						axisTick: {
							alignWithLabel: true,
							show: false
						},
						// 不显示 y 轴的线
						axisLine: {
							show: false
						},
						// y 轴数据
						data: [100, 100, 100, 100],
						// 不显示该 y 轴
						show: false,
					},
				],

				// 配置图表系列
				series: [
					{
						// 系列名称
						name: "条",
						// 系列类型为柱状图
						type: "bar",
						// 使用第一个 y 轴
						yAxisIndex: 0,
						// 系列数据
						data: xValue,
						// 标签配置
						label: {
							// 标签位置
							position: [10, 10], // 在右显示
							normal: {
								// 水平对齐方式为右对齐
								align: 'right',
								// 标签位置
								position: [410, -30],
								// 显示标签
								show: true,
								// 标签文本样式
								textStyle: {
									// 文本颜色
									color: '#1AB49D',
									// 文本大小
									fontSize: 14,
								},
								// 格式化标签文本
								// formatter: '{c}'
							},
							// 标签文本样式
							textStyle: {
								// 数值样式
								// color: '#FAEC00',
								// fontSize: 14
							},
						},
						// 柱状条宽度
						barWidth: 4,
						// 柱状条样式
						itemStyle: {
							normal: {
								// 颜色渐变
								color: function (params) {
									// 根据数据索引获取颜色
									var colorItem = itemColor[params.dataIndex];
									// 返回线性渐变颜色
									return new echarts.graphic.LinearGradient(1, 0, 0, 0, // y->y2
										[
											{
												// 偏移量 0，颜色
												offset: 0,
												color: colorItem[0]
											},
											{
												// 偏移量 1，颜色
												offset: 1,
												color: colorItem[1]
											}
										],
										false,)
								},
							},
						},
						// 系列层级
						z: 2,
					},
					{
						// 系列名称
						name: "白框",
						// 系列类型为柱状图
						type: "bar",
						// 使用第二个 y 轴
						yAxisIndex: 1,
						// 柱状条间距
						barGap: "-100%",
						// 系列数据
						data: [99.5, 99.5, 99.5, 99.5],
						// 柱状条宽度
						barWidth: 10,
						// 柱状条样式
						itemStyle: {
							normal: {
								// 颜色
								color: "#0e1d27",
								// barBorderRadius: 5,
							},
						},
						// 系列层级
						z: 1,
					},
					{
						// 系列名称
						name: "外框",
						// 系列类型为柱状图
						type: "bar",
						// 使用第三个 y 轴
						yAxisIndex: 2,
						// 柱状条间距
						barGap: "-100%",
						// 系列数据
						data: [100, 100, 100, 100],
						// 柱状条宽度
						barWidth: 14,
						// 柱状条样式
						itemStyle: {
							normal: {
								// 颜色
								color: '#5a7581',
								// barBorderRadius: 5,
							},
						},
						// 系列层级
						z: 0,
					},
				],

			};
			Toption && TmyChart.setOption(Toption);
			setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	mounted() {
		this.$nextTick(() => {

			this.cDrawCircle(); //需要刷新的数据
		});
	},
};
</script>

<style scoped lang="scss">
.rc {
	width: 480px;
	height: 240px;
	display: flex;
	padding: 10px 0;
	position: relative;

}

.cmain {

	margin: 20px 0 4px;
	width: 480px;
	height: 240px;
}
</style>